"use client"

import Link from "next/link"
import { A9entLogo } from "@/components/a9ent-logo"
import { cn } from "@/lib/utils"

type BlogPublicHeaderProps = {
  className?: string
}

export function BlogPublicHeader({ className }: BlogPublicHeaderProps) {
  return (
    <header
      className={cn(
        "sticky top-0 z-40 border-b border-white/10 bg-black/80 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-black/60",
        className
      )}
    >
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-4 px-4 sm:h-16 sm:px-6">
        <Link
          href="/"
          className="flex shrink-0 items-center rounded-md outline-none ring-offset-background transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-ring"
        >
          <span className="sr-only">A9ent — Home</span>
          <A9entLogo height={32} darkBackground />
        </Link>
        <nav className="flex items-center gap-0.5 text-sm" aria-label="Blog navigation">
          <Link
            href="/blog"
            className="rounded-md px-3 py-2 font-medium text-foreground transition-colors hover:bg-muted"
          >
            Blog
          </Link>
          <Link
            href="/"
            className="cursor-pointer rounded-full bg-white px-6 py-2 text-sm font-medium text-black transition-all duration-300 hover:bg-gradient-to-r hover:from-cyan-500 hover:via-sky-500 hover:to-blue-600 hover:text-white"
          >
            Get Started
          </Link>
        </nav>
      </div>
    </header>
  )
}
